import React from 'react';
import { Validation } from '../../ReusableComponents/NewDesign/Layout/Layout';

function VendorApplication() {
  return (
    <Validation
      title="Thank you. We’ve received your application."
      text="We’ll email you as soon as we can with an update."
    />
  );
}

export default VendorApplication;
